import { Controller } from "stimulus"

// #1620: het chatvenster. Scrolt naar het nieuwste bericht, ook als er een
// live binnenkomt (Turbo Stream), en meldt de server dat een binnengekomen
// bericht gelezen is zolang de pagina in beeld is. Enter verstuurt op een
// toetsenbord; Shift+Enter is een nieuwe regel.
export default class extends Controller {
  static targets = ["berichten", "invoer", "formulier"]
  static values = { ik: String, gelezenUrl: String }

  connect() {
    this.naarOnder()
    if (!this.hasBerichtenTarget) return

    this.waarnemer = new MutationObserver((wijzigingen) => {
      let vanAnder = false
      wijzigingen.forEach((wijziging) => {
        wijziging.addedNodes.forEach((knoop) => {
          if (knoop.nodeType === 1 && knoop.dataset.afzender && knoop.dataset.afzender !== this.ikValue) vanAnder = true
        })
      })
      this.naarOnder()
      if (vanAnder) this.gelezen()
    })
    this.waarnemer.observe(this.berichtenTarget, { childList: true })
  }

  disconnect() {
    if (this.waarnemer) this.waarnemer.disconnect()
  }

  naarOnder() {
    if (this.hasBerichtenTarget) this.berichtenTarget.scrollTop = this.berichtenTarget.scrollHeight
  }

  gelezen() {
    if (!this.gelezenUrlValue || document.visibilityState !== "visible") return

    const token = document.querySelector("meta[name='csrf-token']")
    fetch(this.gelezenUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token ? token.content : "", "Accept": "text/plain" },
      credentials: "same-origin"
    }).catch(() => {})
  }

  toets(event) {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return
    // Op een telefoon is Enter een nieuwe regel; daar is de knop er
    if (window.matchMedia("(pointer: coarse)").matches) return

    event.preventDefault()
    if (this.invoerTarget.value.trim() === "") return
    this.invoerTarget.form.requestSubmit()
  }

  groei() {
    const veld = this.invoerTarget
    veld.style.height = "auto"
    veld.style.height = Math.min(veld.scrollHeight, 140) + "px"
  }

  verstuurd() {
    this.naarOnder()
    requestAnimationFrame(() => {
      const veld = this.element.querySelector("#chat-invoer")
      if (veld) veld.focus()
    })
  }
}
